/* eslint-disable */
export default {
    form_project_name_placeholder: "Saisir le nom du projet ici",
    form_value_can_not_be_empty: "Cette valeur ne peut pas être vide",
    form_could_not_process_your_request: "Impossible de traiter votre demande",
    form_input_type_could_not_be_determined: "Aucun élément de saisie ne peut être déterminé pour le type :",
    form_could_not_find_form_field: "Aucun champ de formulaire ne peut être trouvé avec l’identifiant :",
    form_submit: "Envoyer",
    form_loading_form: "Chargement du formulaire",
    form_close: "Fermer",
    form_organisation_name: "Nom de l’organisation",
    form_job_function_name: "Nom de la fonction",
    form_job_function_name_placeholder: "Saisir le nom de la fonction ici",
    form_organisation_name_placeholder: "Saisir ici le nom de l’organisation",
    form_project_name: "Nom du projet",
    form_project_product: "Produit",
    form_option_product_selection: "Sélection",
    form_option_product_development: "Développement",
    form_option_product_selection_development: "Développement sélectif",
    form_option_nederlands: "Néerlandais",
    form_option_engels: "Anglais",
    form_account_first_name: "Prénom",
    form_account_infix: "Suffixe",
    form_account_last_name: "Nom de famille",
    form_account_gender: "Sexe",
    form_account_has_role_email: "Adresse e-mail ",
    form_account_has_role_language: "Langue",
    form_education_level: "Quel est le niveau d’études requis ?",
    form_participant_session_appointment_date: "Date du rendez-vous",
    form_comments: "Remarques",
    form_consultant: "Consultant",
    form_option_male: "Homme",
    form_option_female: "Femme",
    form_option_other: "Autre",
    form_participant_first_name_placeholder: "Saisir le prénom du participant",
    form_participant_infix_placeholder: "Saisir le suffixe du participant",
    form_participant_last_name_placeholder: "Saisir le nom de famille du participant",
    form_participant_email_placeholder: "Saisir l’adresse e-mail du participant",
    form_option_choose_language: "Choisir une langue pour le participant",
    form_participant_session_appointment_date_placeholder: "Sélectionner une date",
    form_comments_placeholder: "Saisissez vos commentaires",
    form_option_low: "Enseignement secondaire professionnel",
    form_option_middle: "Enseignement professionnel supérieur",
    form_option_high: "Universitaire",
    form_email: "Adresse e-mail",
    form_account_email_placeholder: "Saisir l’adresse e-mail de l’utilisateur",
    form_account_role_label: "Rôle",
    form_display_name: "Nom d'affichage",
    form_account_display_name_placeholder: "Saisir un nom complet pour l’utilisateur",
    form_infix: "Suffixe",
    form_account_infix_placeholder: "Saisir le suffixe de l’utilisateur",
    form_account_last_name_placeholder: "Saisir le nom de famille de l’utilisateur",
    form_last_name: "Nom de famille",
    form_first_name: "Prénom",
    form_account_first_name_placeholder: "Saisir le prénom de l’utilisateur",
    form_option_role_application_managers: "Gestionnaire d'applications",
    form_option_role_consultants: "Consultant",
    form_option_role_bedrijfsbureau: "Planning & Support",
    form_option_role_backoffice: "Back-office",
    form_option_role_client_center: "Centre clients",
    form_option_role_assessment_team: "Équipe d’évaluation",
    form_option_role_assessors: "Évaluateur",
    form_gender: "Sexe",
    form_option_choose_gender: "Choisir un sexe",
    form_stars_required: "* Champs obligatoires",
    form_option_choose_education_level: "Choisir un niveau d’études",
    form_option_choose_consultant: "Aucun consultant choisi",
    form_option_choose_product: "Choisir un produit",
    form_option_choose_user_role: "Choisir un rôle",
    form_error_not_blank: "Ce champ ne peut pas être vide",
    form_error_length_maximum: "La valeur de ce champ est trop longue",
    form_error_length_minimum: "La valeur de ce champ est trop courte",
    form_error_duplicate_entry: "Cette valeur existe déjà",
    form_error_password_contains_spaces: "Le mot de passe ne doit pas contenir d’espaces",
    form_error_password_do_not_match: "Les mots de passe ne correspondent pas",
    form_error_password_too_short: "Le mot de passe doit contenir au moins 8 caractères",
    form_error_password_too_long: "Le mot de passe est trop long",
    form_error_invalid_email: "L’adresse e-mail n’est pas valide",
    form_error_duplicate_non_participant_role: "Cet utilisateur a déjà été invité avec le rôle sélectionné",
    form_error_invalid_field_value: "La valeur de ce champ n’est pas valide",
    form_error_email_duplicate_in_project: "Ce participant existe déjà",
    form_error_duplicate_custom_competency: "Cette compétence existe déjà",
    form_error_registration_user_already_exists: "Cet utilisateur existe déjà. Cliquer sur Connexion ou Mot de passe oublié pour continuer.",
    form_cancel: "Annuler",
    form_highest_basic_education_level: "Quel est votre plus haut niveau d’éducation dans l’enseignement secondaire ?",
    form_highest_advanced_education_level: "Quel est votre plus haut niveau d’éducation dans l’enseignement supérieur ou professionnel ?",
    form_highest_basic_education_level_placeholder: "Choisir un niveau d’éducation",
    form_highest_advanced_education_level_placeholder: "Choisir un niveau d’éducation",
    form_appendixes_to_hide_online: "Pièces jointes masquées",
    form_account_date_of_birth: "Date de naissance",
    form_appendixes_to_hide_pdf: "Pièces jointes masquées",
    form_option_persona_fit: "Persona.fit",
    form_option_working_styles: "Styles de travail",
    form_option_influencing_styles: "Styles d’influence",
    form_option_motives: "Motivations",
    form_option_personality: "Personnalité",
    form_option_intellectual_capabilities: "Capacité intellectuelle",
    form_error_participant_session_invite_failed: "Échec de l’envoi d’e-mails",
    form_form_fields_not_loaded: "Les champs de formulaire n’existent pas ! L’appel d’API a probablement échoué",
    update_participant_detail_save: "Sauvegarder",
    update_participant_detail_page_heading: "Profil personnel",
    update_participant_detail_form_heading: "Données personnelles",
    update_participant_detail_form_heading_label: "Les informations ci-dessous sont connues de nous",
    form_date_of_birth: "Date de naissance",
    form_report_receivers_placeholder: "Destinataires du rapport",
    form_report_receivers: "Destinataires du rapport",
    form_sub_organisation_name_placeholder: "Saisir ici le nom de la sous-organisation",
    form_sub_organisation_name: "Nom de la sous-organisation",
    form_report_receiver_account_gender: "Sexe",
    form_report_receiver_account_has_role_email: "Adresse e-mail",
    form_report_receiver_account_last_name: "Nom de famille",
    form_report_receiver_account_infix: "Suffixe",
    form_report_receiver_account_first_name: "Prénom",
    form_error_report_receiver_already_exists: "Ce destinataire de rapport existe déjà, sélectionnez-le dans la liste",
    form_option_role_office_manager: "Chef de bureau",
    form_choose_organisations_title: "Organisations",
    form_choose_project_title: "Projet",
    form_product_selection: "Sélection",
    form_product_selection_development: "Développement sélectif",
    form_product_development: "Développement",
    form_many_participant_session_to_one_product: "Produit",
    form_low: "Enseignement secondaire professionnel",
    form_high: "Enseignement universitaire",
    form_middle: "Enseignement professionnel supérieur",
    form_male: "Homme",
    form_other: "Autre",
    form_female: "Femme",
    form_one_participant_session_to_many_active_competency: "Ajouter des compétences",
    "form_nl-_n_l": "Néerlandais",
    "form_en-_g_b": "Anglais",
    form_product_building_docks: "Building Docks",
    form_product_talent_fit: "Talent Fit",
    form_product: "Produit",
    form_error_not_email: "L’adresse e-mail spécifiée n’est pas valide",
    form_product_wpq: "Questionnaire de profil professionnel",
    form_product_personafit2: "Persona.fit 2",
    form_product_wpq_description: "...",
    form_product_persona_fit2_description: "...",
    form_product_building_docks_description: "Fournit un aperçu de la façon dont un participant gère les dilemmes moraux.",
    form_product_talent_fit_description: "Déterminer rapidement et objectivement l'adéquation entre le talent et l'environnement de travail (fonctions enseignement professionnel supérieur/universitaire). Avec des conseils de développement pour le participant et des questions d'entretien pour l'intervieweur.",
    form_product_selection_description: "Fournit un aperçu de l’adéquation entre le profil d'un participant et une fonction spécifique.",
    form_product_selection_development_description: "Fournit un aperçu de l’adéquation entre le profil d'un participant et une fonction spécifique. Plus des conseils de développement ",
    form_product_development_description: "Fournit un aperçu des qualités, des points susceptibles de développement et de la capacité d'un participant à évoluer.",
    form_error_selected_product_is_invalid_for_parent_organisation: "Le produit sélectionné n’est pas valide pour cette organisation",
    form_input_value_too_short: "La valeur spécifiée doit contenir 2 caractères au minimum et 255 au maximum.",
    form_input_value_too_long: "La valeur spécifiée doit contenir 2 caractères au minimum et 255 au maximum.",
    form_input_value_required: "Ce champ est obligatoire.",
    form_choose_product_title: "Produit",
    form_choose_completed_start_title: "Date de début",
    form_choose_completed_end_title: "Date de fin",
    form_product_persona_fit_2: "Persona.fit",
    form_option_role_finance: "Administration finances",
    form_enable_ability_tests: "Faire passer le(s) test(s) d’aptitude",
    form_ps_report_receivers: "Destinataires du rapport",
    form_product_talent_navigator_description: "Rapport de développement rapide et objectif avec un aperçu des points forts et à développer. Commencer à examiner le développement d'un employé.",
    form_product_talent_navigator: "Talent Navigator",
    form_product_add_on_integrity: "Intégrité",
    form_product_add_on_integrity_description: "Cette orientation indique jusqu’à quel point le participant agit avec intégrité. Le rapport indique si le participant agit plutôt dans l'intérêt individuel ou collectif compte tenu de son profil et de son attitude.",
    form_is_demo_participant: "S’agit-il d’un participant à la démonstration ?",
    form_product_add_on: "Orientation (facultatif)",
    form_option_role_client_admin: "Administration clients",
    form_product_pre_fit_description: "Identifier rapidement les meilleurs candidats pour la prochaine étape du processus de sélection.",
    form_product_pre_fit: "Pre Fit",
    form_cost_heading: "Centre de coûts (facultatif)",
    form_choose_cap_test_domain: "Les tests d'aptitude indiqués ci-dessous sont inclus dans le programme.",
    form_choose_cap_test_domain_helper_text: "Choisissez au moins deux domaines facultatifs pour augmenter la fiabilité. Si vous ne choisissez pas de domaine facultatif, le test G général sera utilisé et vous verrez le score sur la capacité intellectuelle générale dans le rapport. Attention : ce choix affecte le temps de test.",
    "form_de-_d_e": "Allemand",
    "form_fr-_f_r": "Français",
    form_product_talent_scan_description: "Un outil de sélection en ligne qui vous aide à sélectionner les employés les plus talentueux pour les postes d’enseignement secondaire professionnel.",
    form_product_talent_scan: "Talent Scan",
    form_product_add_on_work_safely: "Work safely",
    form_product_add_on_dealing_with_resistance: "Dealing with resistance",
    form_product_add_on_derailment: "Gérer la pression",
    form_password_show: "Show",
    form_password_hide: "Hide",
    form_saved_changes: "Changes are saved",
    form_unsaved_changes: "Changes are unsaved",
    form_save_button: "Save",
    form_product_multi_phase: "2-Phase Talent Fit",
    form_product_multi_phase_description: "A two-phased online selection tool that helps select the best participants from a large pool of applicants.",
    form_choose_roles_subtitle: "Below you will find the different roles within Neon. Choose one or more roles.",
    form_choose_roles_title: "Which role(s) do you want to add?",
    form_choose_reports_title: "Which reports can the user see?",
    form_choose_reports_subtitle: "Choose one of the options below.",
    form_option_role_office_manager_no_report: "Coordinateur",
    form_choose_organisations_subtitle: "Choose the organization that the user has access to.",
    form_choose_organisations_title_descriptive: "Which organization do you want to add the user to?",
    form_choose_organisations_placeholder: "Choose organisation",
    form_option_role_report_receiver: "Destinataire du rapport",
    form_all_reports_title: "All reports",
    form_all_reports_description: "With this role the user can see the reports of all participants of this organization.",
    form_no_reports_title: "No reports",
    form_no_reports_description: "The user can add participants but will not see any reports.",
    form_amend_roles_title: "Role(s)",
    form_product_add_on_critical_thinking: "Critical thinking",
    form_product_add_on_critical_thinking_description: "This add-on provides insight into the extent to which the participant is able to separate fact from assumptions and subsequently draw the correct conclusions.",
    form_product_add_on_derailment_description: "Cette extension donne un aperçu des comportements toxiques qui peuvent émerger sous pression chez l'employé.",
    form_product_add_on_work_safely_description: "This add-on provides the insight in the factors that influence the risk-taking in the field of working safely.",
    form_product_add_on_dealing_with_resistance_description: "The way in which the employee deals with resistance determines work performance. This add-on provides insight into the risks.",
    form_product_add_on_no_extra_time: "No extra time",
    form_product_add_on_integrity_extra_time: "±45 minutes",
    form_product_add_on_critical_thinking_extra_time: "±30 minutes",
    form_product_team_and_organisation: "Team & Organisation",
    form_product_team_and_organisation_description: "This product fosters transparent communication and provides intuitive collaboration tools, enabling teams and organizations to better understand each other's perspectives and foster cohesion.",
    form_product_add_on_dilemma_test: "Dilemma test",
    form_product_add_on_dilemma_test_description: "An ethical dilemma test evaluates the decision-making process in complex situations to assess ethical reasoning. It tests the ability to analyze scenarios and make informed judgments based on moral principles.",
    form_product_add_on_dilemma_test_extra_time: "±30 minutes",
    form_download: "Télécharger",
    form_assessment_form_description: "How would you like your assessment to take place? You can choose two options: online only and including the interpretation by a psychologist.",
    form_assessment_form_title: "Design your assessment",
    form_assessment_form_with_interpretation_title: "Online, with live interpretation and interview",
    form_assessment_form_without_interpretation_title: "Online assessment",
    form_assessment_form_with_interpretation_description: "This option is chosen when you want to add the interpretation by an LTP psychologist additionally. This makes decision-making even easier",
    form_assessment_form_without_interpretation_description: "The standard is an automated report after completion of the questionnaires. There is no interpretation from an LTP psychologist.",
    form_assessment_form_without_interpretation_time_indication: "No extra time",
    form_assessment_form_with_interpretation_time_indication: "+ 3 - 8 hours on LTP location",
    form_points_of_attention: "Y a-t-il des points d’intérêt, des informations supplémentaires sur le profil ou le participant ?",
    form_points_of_attention_placeholder: "Écrivez des informations supplémentaires pour que nous puissions en tenir compte",
    form_project_prompt_name_placeholder: "Add the job title as used in AI prompts here",
    form_project_prompt_description_placeholder: "Add information about this job function that will be used in AI prompts",
    form_assessment_interpretation_title: "Interpretation",
    form_assessment_interpretation_description: "By selecting this is option, you can add interpretation by a psychologist to your online assessment.",
    form_assessment_interpretation_enabled: "Enabled",
    form_assessment_interpretation_disabled: "Disabled",
    form_product_test_ned: "",
    form_product_test_ned_description: "",
    form_product_test_ned_periodic: "",
    form_product_test_ned_periodic_description: "",
    form_interpretation_basic: "Interpretation Silver",
    form_interpretation_compact: "Interpretation Compact",
    form_interpretation_regular: "Interpretation Gold",
    form_interpretation_premium: "Interpretation Premium",
    form_file_uploader_button: "",
    form_profile_files_title: "2. Fichiers joints au profil",
    form_error_password_not_valid: "Le mot de passe doit comporter au moins 12 caractères, contenir un caractère majuscule et minuscule, un caractère spécial et un chiffre",
    form_assessment_goal_description: "Choose from mapping development potential, a selection issue or a combination of both.",
    form_assessment_goal_title: "Choose your goal",
    form_assessment_form_development_description: "Découvrez le potentiel de développement",
    form_assessment_form_selection_development_description: "Trouvez les candidats les plus adaptés à un poste et examinez le potentiel de développement",
    form_assessment_form_selection_description: "Trouvez les candidats les plus appropriés pour un poste",
    form_assessment_form_development_title: "Development",
    form_assessment_form_selection_development_title: "Selection Development",
    form_assessment_form_selection_title: "Selection",
    form_unspecified: "Je préfère ne pas dire ça",
    form_option_unspecified: "Je préfère ne pas dire ça",
    form_raf_product_selection: "",
    form_raf_product_selection_development: "",
    form_raf_product_development: "",
    form_interpretation_periodicAssessmentTestNed: "TestNed Scan Periodic",
    form_language: "Preferred language",
    form_profile_cv_title: "1. CV : Le participant sera invité à télécharger son CV",
    form_plan_in_neon_toggle_label: "Enregistrez les détails des rendez-vous liés à l’AFAS directement dans NEON",
    form_participant_files_title: "3. Ajouter des fichiers liés aux participants",
    form_product_no_online_scan: "",
    form_product_no_online_scan_description: "",
    form_file_item_upload_fail: "",
    form_file_item_upload_success: "",
    form_project_files_uploader_drag_and_drop: "Glisser-déposer des fichiers de projet",
    form_files_uploader_remove_file_modal_description: "",
    form_files_uploader_remove_file_modal_delete_button: "",
    form_files_uploader_remove_file_modal_title: "",
    form_files_uploader_error_upload: "",
    form_files_uploader_error_delete: "",
    form_files_uploader_error_open: "",
    form_is_pre_assessment_call_necessary: "Un appel de pré-évaluation avec le manager est-il nécessaire ?",
    form_manager_name_placeholder: "Nom du gérant",
    form_manager_phone_placeholder: "Numéro de téléphone du responsable",
    form_manager_name_label: "",
    form_manager_phone_label: "",
    form_report_receivers_add: "",
    form_report_receivers_empty_state_header: "",
    form_report_receivers_empty_state_paragraph_1: "",
    form_report_receivers_empty_state_paragraph_2: "",
    form_update_button_label: "",
    form_report_receivers_remove_tooltip: "",
    form_cv_uploader_drag_and_drop: "Glisser-déposer le fichier CV",
    form_file_uploader_paragraph: "ou, cliquez pour naviguer",
    form_file_uploaded_success: "Le fichier a été téléchargé avec succès",
    form_education_level_description: "The requested level is needed to give you the right assessment for your question. In addition, it is also used for the capacity tests if these are included in the program.",
    form_education_level_title: "What is the required level for this profile?",
    form_education_level_low_description: "This profile is an \"executive\" profile in which the participant primarily works in execution.",
    form_education_level_middle_description: "This profile is a \"professional\" profile in which the participant focuses not only on execution but also on policy.",
    form_education_level_high_description: "This profile is a \"professional or executive\" profile in which the participant has a policy focus or is suited for higher executive positions.",
    form_education_level_high_title: "Master's degree",
    form_education_level_middle_title: "Higher vocational program",
    form_education_level_low_title: "Middle manual vocational program",
    form_product_executive_scan: "Executive Scan",
    form_product_executive_scan_description: "A scan for executive positions aimed at measuring leadership qualities, strategic insight, and personal effectiveness, with critical reasoning as a standard component of the program.",
    form_error_email_contains_space: "L'adresse e-mail ne peut pas contenir d'espace",
    form_interpretation_executive: "Compact Executive Assessment",
    form_interpretation_cLevel: "Executive Assessment",
    form_internal_participant_toggle_checked: "",
    form_internal_participant_toggle_unchecked: "",
    form_pre_assessment_call_toggle_unchecked: "",
    form_points_of_attention_short: "Points d'attention",
    form_participant_phone_label: "Participant's phone number",
    form_participant_employee_number: "Numéro d’employé",
    form_invited_email_address: "Invited e-mail address",
    form_registered_email_address: "Registered e-mail address",
    form_warning_email_addresses_different: "The invited and registered e-mail addresses are not the same",
    form_files_uploader_error_file_size: "",
    form_career_position_starter_title: "",
    form_career_position_professional_title: "",
    form_career_position_manager_title: "",
    form_career_position_executive_title: "",
    form_option_role_team_manager: "Team Manager",
    form_option_role_team_admin: "Team Admin",
    form_simple_raf_your_choices: "",
    form_career_position_description: "En fonction du niveau, nous composons le programme adapté et choisissons un conseiller adapté.",
    form_career_position_title: "Quel est le niveau du poste ?",
    form_career_position_professional_description: "",
    form_career_position_manager_description: "",
    form_career_position_executive_description: "",
    form_assessment_goal_simple_raf_title: "Quel est le rôle de l'évaluation ?",
    form_assessment_goal_simple_raf_description: "Les évaluations portent essentiellement sur le potentiel des candidats. Nous pouvons les utiliser (en fonction des priorités) avec une aide à la sélection.",
    form_assessment_form_simple_raf_development_title: "Développement",
    form_assessment_form_simple_raf_selection_development_title: "Développement avec décision de sélection",
    form_education_level_simple_raf_title: "Quel est le niveau d’études requis?",
    form_education_level_simple_raf_description: "Sur cette base, nous définissons le niveau de l’évaluation et les tests de capacité.",
    form_assessment_form_simple_raf_title: "Qu’attendez-vous du résultat de l’évaluation ?",
    form_assessment_form_simple_raf_description: "Nos conseillers établissent une évaluation sur la base d'outils scientifiques que le participant remplit lui-même, d'un entretien personnel approfondi, éventuellement d'un ou plusieurs travaux pratiques et d'un rapport écrit. Vous pouvez également choisir de ne connaître le participant qu'à l'aide d'outils scientifiques.",
    form_assessment_form_simple_raf_without_interpretation_title: "Insight (en ligne uniquement)",
    form_assessment_form_simple_raf_with_interpretation_title: "Informations et conseils"
};
